import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import VJsoneditor from 'v-jsoneditor/src/index'
import VueClipboard from 'vue-clipboard2'

//import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'
import './assets/custom.sass'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './styles/next-ui.css'
import VuetifyConfirm from 'vuetify-confirm'

import ru from 'vuetify/src/locale/ru.ts'

import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

const opts = {
    lang: {
        locales: { ru },
        current: 'ru',
    },
    theme:{
        primary: '#4D5F71',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        light:{
            primary: '#4D5F71',
            secondary: '#424242',
            accent: '#82B1FF',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FFC107'
        }

    },
    icons: {
        iconfont: 'mdi',
        dark: false,

        themes: {
            light: {
                primary: '#4D5F71',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
            },
            dark: {
                primary: '#4D5F71',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
            }
        }
    }

};



Vue.use(VueCookie);


Vue.use(Vuetify);



Vue.use(VuetifyConfirm, { vuetify: new Vuetify(opts), buttonTrueText: 'Да', buttonFalseText: 'Нет' });
Vue.use(VJsoneditor)
Vue.use(VueClipboard);

import { initOktaAuth, getAuthModes } from './okta/okta-auth';
import { initCurrencies } from './util/currency';

const { isOktaEnabled } = getAuthModes();
if (isOktaEnabled) {
    initOktaAuth();
}

Vue.config.productionTip = false

router.afterEach(() => {
    Vue.nextTick( () => {
        document.title = 'Smart Payments Admin';
    });
})

initCurrencies().then(() => {
    new Vue({
        vuetify: new Vuetify(opts),
        router,
        store,
        render: h => h(App),
    }).$mount('#app');
}).catch(err => {
    console.error('Failed to load currencies config', err);
    new Vue({
        vuetify: new Vuetify(opts),
        router,
        store,
        render: h => h(App),
    }).$mount('#app');
});
